import React from "react";

const WomensHealth = () => {
  return (
    <div style={{ minHeight: 150, padding: "8px 12px", color: "#444" }}>
      Not Applicable
    </div>
  );
};

export default WomensHealth;
